<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" label-width="80px">
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="品牌:">
            <el-radio-group v-model.number="searchForm.brand_id" @change="checkInput">
              <el-radio :label="1">N牌</el-radio>
              <el-radio :label="2">S牌</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="10">
          <el-form-item label="日期:">
            <el-date-picker v-model="searchForm.day" type="date"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="單號:">
            <el-input v-model="searchForm.number" style="width: 50%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="10">
          <el-form-item label="店櫃:">
            <el-select v-model="searchForm.shopKey" filterable>
              <el-option
                v-for="item in shopList"
                :label="item.name"
                :value="item._key"
                :key="item._key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="狀態:">
            <el-radio-group v-model.number="searchForm.status">
              <el-radio :label="1">完成</el-radio>
              <el-radio :label="2">作廢</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="12">
          <el-button type="primary" icon="el-icon-search" @click="fetchOrderChangeList"
            >查詢</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <!-- <el-col :lg="6" :offset="18">
            <el-button type="primary" @click="dialogFormVisible = true">報表</el-button>
            <el-dialog title="報表" :visible.sync="dialogFormVisible" width="40%" center>

                <el-form :v-model="excelForm" label-width="90px">
                    <el-row justify="center" align="center">
                        <el-col :span="22" :offset="2">
                            <el-form-item label="品牌:">
                                <el-radio-group v-model.number="excelForm.brand_id" @change="checkInput">
                                    <el-radio :label="1">N牌</el-radio>
                                    <el-radio :label="2">S牌</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="22" :offset="2">
                            <el-form-item label="日期間格:">
                                <el-date-picker v-model="excelForm.date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="22" :offset="2">
                            <el-form-item label="店櫃:">
                                <el-select v-model="excelForm.shopKey" filterable>
                                    <el-option v-for="item in shopList" :label="item.name" :value="item._key" :key="item._key"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-row justify="center" align="center">

                </el-row>

                <span slot="footer">
                    <el-button @click="dialogFormVisible= false">取 消</el-button>
                    <el-button type="primary" @click="downExcel">匯 出</el-button>
                </span>
            </el-dialog>

        </el-col> -->
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :lg="22">
        <el-table
          :data="
            orderChangeList.slice((currentPage - 1) * pagesize, currentPage * pagesize)
          "
          :header-cell-style="tableHeaderColor"
          empty-text="暫無數據"
        >
          <el-table-column prop="create_datetime" label="日期"> </el-table-column>
          <el-table-column label="單號" prop="id"></el-table-column>
          <el-table-column label="店櫃" prop="shop_name"></el-table-column>
          <el-table-column label="會員" prop="member_name"></el-table-column>
          <el-table-column label="金額" prop="total"></el-table-column>
          <el-table-column label="狀態" prop="status">
            <template slot-scope="scope">
              <el-tag type="info" effect="dark">
                {{ scope.row.status == 1 ? "完成" : "作廢" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="詳細">
            <template slot-scope="scope">
              <el-button
                type="info"
                icon="el-icon-more"
                @click="detailTabs(scope.$index, scope.row)"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total1"
          @current-change="current_change"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import toExcel from "@/excel/json2excel";

export default {
  name: "search",
  data() {
    return {
      searchForm: {
        brand_id: 0,
        shopKey: "",
        day: "",
        id: "",
        status: null,
      },
      orderChangeList: [],
      excelForm: {
        brand_id: 1,
        date: [],
        shop_key: "",
      },
      shopList: [],
      date: "",
      orderKey: "",
      orderTotal: null,
      total1: 0,
      currentPage: 1,
      pagesize: 10,
      bid: {},
      dialogVisible: false,
      dialogFormVisible: false,
      itemName: "",
      itemQty: "",
      itemPrice: "",
      itemId: "",
      items: [],
      orderExcel: [],
      productDetail: [],
    };
  },
  computed: mapGetters([
    "getOrderChangeList",
    "getShopList",
    "getOrderChangeExcel",
    "getProductDetail",
  ]),
  methods: {
    ...mapActions([
      "fetchOrderChangeList",
      "fetchShop",
      "fetchOrderChangeExcel",
      "fetchProductDetail",
    ]),
    async fetchOrderChangeList() {
      if (this.searchForm.day.length != 0) {
        this.date = moment(this.searchForm.day).format("YYYY-MM-DD");
      } else {
        this.date = "";
      }
      const data = {
        type: 2,
        brand_id: this.searchForm.brand_id,
        create_datetime: this.date,
        shop_key: this.searchForm.shopKey,
        id: this.searchForm.id,
        status: this.searchForm.status,
      };
      await this.$store.dispatch("fetchOrderChangeList", data);
      this.orderChangeList = this.getOrderChangeList;
      this.total1 = this.orderChangeList.length;
    },
    async fetchShopList() {
      if (this.searchForm.brand_id != 0) {
        this.bid = {
          brand_id: this.searchForm.brand_id,
        };
      } else {
        this.bid = {};
      }
      if (this.excelForm.brand_id != 0) {
        this.bid = {
          brand_id: this.excelForm.brand_id,
        };
      } else {
        this.bid = {};
      }
      await this.$store.dispatch("fetchShop", this.bid);
      this.shopList = this.getShopList;
    },
    checkInput() {
      this.fetchShopList();
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `background-color: gray;color: #000;`;
      }
    },
    detailTabs(index, row) {
      this.orderKey = row._key;
      this.orderTotal = row.total;
      this.$emit("detailTabs", this.orderKey, this.orderTotal);
    },
    async downExcel() {
      if (this.excelForm.date.length != 0) {
        this.startDay = moment(this.excelForm.date[0]).format("YYYY-MM-DD");
        this.endDay = moment(this.excelForm.date[1]).format("YYYY-MM-DD");
      } else {
        this.startDay = "";
        this.endDay = "";
      }
      const data = {
        brand_id: this.excelForm.brand_id,
        start_date: this.startDay,
        end_date: this.endDay,
        shop_key: this.excelForm.shopKey,
      };
      await this.$store.dispatch("fetchOrderChangeExcel", data);

      this.orderExcel = this.getOrderChangeExcel;

      for (let i = 0; this.orderExcel != null && i < this.orderExcel.length; i++) {
        if (this.orderExcel[i] != null) {
          this.items = this.orderExcel[i].change_items;
          for (let j = 0; this.items.to != null && j < this.items.to.length; j++) {
            const data = {
              type: this.items.to[j].type,
              _key: this.items.to[j]._key,
            };
            await this.$store.dispatch("fetchProductDetail", data);
            this.productDetail = this.getProductDetail;
            if (this.productDetail != null) {
              this.itemId += this.getProductDetail.id + "\n";
            }

            this.itemPrice += this.items.to[j].price + "\n";
            this.itemName += this.items.to[j].name + "\n";
            this.itemQty += this.items.to[j].qty + "\n ";
          }
        }

        this.orderExcel[i].item_name = this.itemName;
        this.orderExcel[i].item_qty = this.itemQty;
        this.orderExcel[i].item_id = this.itemId;
        this.orderExcel[i].item_price = this.itemPrice;
        this.itemPrice = "";
        this.itemId = "";
        this.itemName = "";
        this.itemQty = "";
        this.items = [];
      }

      this.DataExcel(this.orderExcel, this.startDay, this.endDay);
    },

    async DataExcel(datas, statDay, endDay) {
      const th = [
        "會員卡號",
        "會員姓名",
        "店櫃名稱",
        "換貨日期",
        "換貨單號",
        "品號",
        "品名",
        "換貨數量",
        "電子錢包支付",
        "現金支付",
      ];
      const filterVal = [
        "card_number",
        "member_name",
        "shop_name",
        "create_datetime",
        "id",
        "item_id",
        "item_name",
        "item_qty",
        "use_e_pay",
        "paid",
      ];
      const data = datas.map((v) => filterVal.map((k) => v[k]));
      let tableName = "換貨單";
      if (statDay != "" && endDay != "") {
        tableName = tableName + statDay + "-" + endDay;
      }
      const [fileName, fileType, sheetName] = [tableName, "xlsx", tableName];
      toExcel({
        th,
        data,
        fileName,
        fileType,
        sheetName,
      });
    },
  },
  created() {
    this.fetchShopList();
  },
};
</script>

<style lang="less" scoped></style>
